import { c as _c } from "react/compiler-runtime";
import { useTranslations } from "next-intl";
import { Link } from "@/i18n/navigation";
import { type Tool } from "@/lib/tools";
import { Icon } from "@/lib/icons";
import { type AppPathname } from "@/i18n/pathnames";
export function ToolCard(t0) {
  const $ = _c(21);
  const {
    tool
  } = t0;
  const t = useTranslations("Tools");
  let t1;
  if ($[0] !== t || $[1] !== tool.name || $[2] !== tool.slug) {
    t1 = t(`${tool.slug}.name` as any) || tool.name;
    $[0] = t;
    $[1] = tool.name;
    $[2] = tool.slug;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const toolName = t1;
  let t2;
  if ($[4] !== t || $[5] !== tool.description || $[6] !== tool.slug) {
    t2 = t(`${tool.slug}.description` as any) || tool.description;
    $[4] = t;
    $[5] = tool.description;
    $[6] = tool.slug;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const toolDescription = t2;
  const href = `/${tool.slug}` as AppPathname;
  let t3;
  if ($[8] !== tool.icon) {
    t3 = <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-indigo-50 text-indigo-600 transition-colors group-hover:bg-indigo-600 group-hover:text-white"><Icon name={tool.icon} className="h-6 w-6" /></span>;
    $[8] = tool.icon;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== toolName) {
    t4 = <span className="block font-semibold text-slate-900">{toolName}</span>;
    $[10] = toolName;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== toolDescription) {
    t5 = <span className="mt-1 block text-sm leading-snug text-slate-600">{toolDescription}</span>;
    $[12] = toolDescription;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t4 || $[15] !== t5) {
    t6 = <span className="min-w-0">{t4}{t5}</span>;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== href || $[18] !== t3 || $[19] !== t6) {
    t7 = <Link href={href} className="group flex items-start gap-4 rounded-xl border border-slate-200 bg-white p-5 transition-all hover:border-indigo-300 hover:shadow-md">{t3}{t6}</Link>;
    $[17] = href;
    $[18] = t3;
    $[19] = t6;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  return t7;
}